<template>
  <div class="info-item">
    <span class="label">{{ label }}</span>
    <span
      v-empty
      class="value"
    >
      <slot />
    </span>
  </div>
</template>
<script>
export default {
  name: 'InfoItem',
  directives: {
    empty: {
      componentUpdated (el) {
        if (el.innerHTML === '  ') {
          el.innerHTML = '暂无';
        }
      },
    },
  },
  props: {
    label: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.info-item {
  color: rgba($--base-color-black, 1);
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  min-width: 120px;
  span.label {
    margin-right: 8px;
    text-align: right;
    min-width: 90px;
    font-weight: 600;
  }
  span{
    display: inline-flex;
    align-items: center;
  }
}
</style>
